import {
  ConductorTask,
  parseTaskReferenceName
} from 'Automations/nodeDefinitions/conductor'

export const getTasksForNode =
  (tasks: Array<ConductorTask>) => (nodeId: string) => {
    return tasks.filter(task => {
      const { nodeId: taskNodeId } = parseTaskReferenceName(
        task.taskReferenceName
      )
      return taskNodeId === nodeId
    })
  }
